import { render, staticRenderFns } from "./contactus.vue?vue&type=template&id=271215bf&scoped=true&"
import script from "./contactus.vue?vue&type=script&lang=js&"
export * from "./contactus.vue?vue&type=script&lang=js&"
import style0 from "./contactus.vue?vue&type=style&index=0&id=271215bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271215bf",
  null
  
)

export default component.exports